import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CountryService } from '../../../_services/patient-portal-country.service';

@Component({
  selector: 'ngx-patientportalheaders',
  templateUrl: './patientportalheaders.component.html',
  styleUrls: ['./patientportalheaders.component.scss']
})
export class PatientportalheadersComponent implements OnInit, OnChanges {

  @Input() wellSpringAppFlag: boolean = false;
  @Input() tenantId: string | null = null;
  // Second Opinion tenants get the Region selector even in tenant mode - resolved
  // asynchronously by the parent (after resolveTenant()'s auth/validtenant response comes
  // back), so it's read reactively via ngOnChanges below rather than only once in ngOnInit.
  @Input() secondOpinionFlag: boolean = false;
  // Dynamic WellSpring logo (tenant banner, or the virtual-tenant one for the
  // no-tenant flow) resolved by the login component - falls back to the static
  // WellSpring asset below when not passed in or when nothing was fetched.
  @Input() customerLogo: string | null = null;
  @Output() assesClick = new EventEmitter<void>();
  @Output() homeClick = new EventEmitter<void>();
  @Output() bookingClick = new EventEmitter<string>();
  @Output() profileClick = new EventEmitter<void>();
  @Output() onClickCountry = new EventEmitter<string>();
  @Output() secondOpinionClick = new EventEmitter<void>();
  user: any;
  countryCodeDropDownLists: Array<any> = [];
  selectedCountryCode: string = '';
  selectedCountryName: string = '';
  storedCountryCode:string='';
  isregionSelected: boolean = false;
  selectedMenu: string = '';
  protected readonly unsubscribe$ = new Subject<void>();
  countryDetail:any={};
  showRegionPopup: boolean = false;
  constructor(private router: Router,protected http:HttpClient,private patAptSrv: PatientAppointmentData,private route: ActivatedRoute, private countryService: CountryService) { }

  ngOnInit(): void {
    this.user = localStorage.getItem('userName');
    // Tenant-based Care Sphere role login (well-spring-login/:tenantId) resolves its own tenant
    // country server-side, so the geo-detection/country-master fetch here is skipped for it -
    // unless it's a Second Opinion tenant (see initCountrySelector()/ngOnChanges() below).
    if (!this.tenantId || this.secondOpinionFlag) {
      this.initCountrySelector();
    }
    this.setSelected('home');
  }

  ngOnChanges(changes: SimpleChanges): void {
    // secondOpinionFlag arrives asynchronously (set by the parent only after its
    // resolveTenant() call resolves) - if it flips true after ngOnInit already ran (and
    // skipped the fetch because tenantId was set), fetch the country list now.
    if (changes.secondOpinionFlag && this.secondOpinionFlag && this.countryCodeDropDownLists.length === 0) {
      this.initCountrySelector();
    }
  }

  private initCountrySelector(): void {
    this.storedCountryCode = localStorage.getItem('countryCode');
    if (!this.storedCountryCode) {
      this.detectUserCountry();
    } else {
      this.loadCountryMaster();
    }
  }

 gotoHome() {
    this.homeClick.emit(); 
  }

  gotoBooking(routingPath: string) {
    if(routingPath == 'doc'){
      localStorage.setItem('isPatientDoc', 'true');
    }
    this.bookingClick.emit(routingPath);  
  }

  onClickProfile() {
    this.profileClick.emit();
  }

  detectUserCountry() {
    this.http.get<any>('https://ipapi.co/json/').subscribe(res => {
      this.countryDetail = res;
    },(error)=>{
      if(!(localStorage.getItem('countryCode'))) this.showRegionPopup = true;
      this.loadCountryMaster();
    },()=>{
      this.loadCountryMaster();
    });
  }

  loadCountryMaster(): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        this.countryCodeDropDownLists = data.details;
        
      }, (error) => {
        if(error.status==401){
          this.router.navigateByUrl('/auth/patient-portal');
        }
      }, () => {
      if(this.countryCodeDropDownLists.length > 0 && Object.keys(this.countryDetail).length>0){
        this.selectedCountryCode = this.countryCodeDropDownLists.find(x => x.countryCode == this.countryDetail?.country_calling_code)?.id;
      }else if(this.storedCountryCode){
        this.selectedCountryCode = this.countryCodeDropDownLists.find(x => x.countryCode == this.storedCountryCode)?.id;
      }
    });
  }

  onSelectCountryCode(event: any) {
    if(event){
      this.isregionSelected = true;
      this.selectedCountryCode = event[0]?.data?.id;
      localStorage.setItem('countryCode', event[0]?.data?.countryCode);
      this.countryService.setCountryCode(event[0]?.data?.countryCode);
      this.selectedCountryName = event[0]?.data?.name;
      this.onClickCountry.emit(this.selectedCountryName);
    }

  }

  // The "Unable to detect your region" popup's plain <select> (change) handler -
  // resolves the chosen id back into the full country record so it can go
  // through the same persistence/emit steps as everywhere else here.
  onRegionPopupSelect(): void {
    const country = this.countryCodeDropDownLists.find((c: any) => c.id === this.selectedCountryCode);
    if (!country) { return; }
    this.isregionSelected = true;
    localStorage.setItem('countryCode', country.countryCode);
    this.countryService.setCountryCode(country.countryCode);
    this.selectedCountryName = country.name;
    this.onClickCountry.emit(this.selectedCountryName);
  }

  setSelected(menu: string) {
    this.selectedMenu = menu;
  }



  onClickSelfAssesment(){
    this.assesClick.emit();
  }

  gotoSecondOpinion() {
    this.secondOpinionClick.emit();
  }

}
